import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule ,ReactiveFormsModule} from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { RegistroAspiranteComponent } from './registro-aspirante/registro-aspirante.component';
import { PreinscribirComponent } from './preinscribir/preinscribir.component';
import { AvisosModalesComponent } from './avisos-modales/avisos-modales.component';


@NgModule({
  declarations: [
    LoginComponent,
    RegisterComponent,
    RegistroAspiranteComponent,
    PreinscribirComponent,
    AvisosModalesComponent

  ],
  exports: [
    LoginComponent,
    RegisterComponent,
    RegistroAspiranteComponent,
    PreinscribirComponent,
    AvisosModalesComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class AuthModule { }
